import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { QUARTERLY_ALL_ACTIONS_TYPE } from "../../redux/actions-type";
import GlobalHead from "../../globalComponents/GlobalHead/GlobalHead";
import { getQuarterlyTargetPlanAction } from "../../redux/actions/quarterlyTargetPlanActions";
import { toast } from "react-toastify";
import QuarterlyTargetPlanData from "./components/QuarterlyTargetPlanData";

const QuarterlyTargetPlanPage = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.quarterlyTargetPlanData);
  const { courseId } = useSelector((state) => state.studentStatus);

  const { startDate, endDate } = useSelector((state) => state.datepicker);

  const filter = () => {
    if (loading) return;

    if (!startDate || !endDate) {
      toast.error("Tarix seçilməyib", {
        position: "top-right",
        autoClose: 2000,
        toastClassName: "custom-toast",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }

    dispatch({
      type: QUARTERLY_ALL_ACTIONS_TYPE.RESTE_QUARTERLY_TARGET_PLAN,
    });

    dispatch(getQuarterlyTargetPlanAction(startDate, endDate, courseId));
  };

  useEffect(() => {
    if (startDate && endDate) {
      dispatch(getQuarterlyTargetPlanAction(startDate, endDate, courseId));
    }

    return () => {
      dispatch({
        type: QUARTERLY_ALL_ACTIONS_TYPE.RESTE_QUARTERLY_TARGET_PLAN,
      });
    };
  }, []);

  return (
    <div className="details-page rooms">
      <GlobalHead
        searchData={""}
        openModal={() => {}}
        filter={filter}
        DATA_SEARCH_VALUE={""}
        dataSearchValues={""}
        profile="quarterly-target-plan"
        statusType={"quarterly-target-plan"}
        count={0}
      />

      <QuarterlyTargetPlanData />
    </div>
  );
};

export default QuarterlyTargetPlanPage;
